export default s => s ? (s + (s.substr(-1) == 's' ? '’' : '’s')) : s ;
